import _ from "lodash";
import React from "react";
import {
  CURRICULUM_TYPE_DP,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_UBD,
  ROLE_VISITOR,
} from "Constants/stringConstants";
import { getCountryOptions } from "@toddle-edu/common-utils";
import { parseMenuItems, AdminMenu } from "Administrator/AdminMenu";
import {
  getAdminNode,
  handleAdminSidebarMenuItemClick,
  handleAdminSidebarBackButtonClick,
  getAdminNodesWithUpdatedChildren,
} from "Administrator/modules/AdministratorModule";
import { getOrganizationCurriculumProgramsFromCache } from "modules/CommonGraphqlHelpers";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import { getSettingValue } from "modules/PermissionModule";
import { getPaidCurriculumPrograms } from "Platform/modules/PlatformUtils";
import ACLStore from "lib/aclStore";
import {
  CURRICULUM_TYPE_ORDER_MAPPING,
  LANGUAGE_OPTIONS,
  colors,
  fontStyle,
} from "Constants";
import i18next from "i18next";
import {
  getUserCurriculumPrograms,
  getOrganizationCurriculumPrograms,
  getCurrentAcademicYear,
} from "modules/CommonSelectors";
import {
  generateConfigurationQueryVariables,
  getAllCurriculumsAdminConfigurationsObject,
} from "ChildrenPage/modules/ChildrenPageUtils";
import { getConfigurationsFromCacheV2 } from "ChildrenPage/modules/ChildrenPageGraphqlHelpers";
import {
  MODULE_CONFIGURATION_MAP,
  CURRICULUM_MODULE_MAP,
  getAccessLevels,
  getIsAdminByRole,
  MODULES,
} from "lib/staffPermissionUtils";
import moment from "moment";
import { getAcademicYearsList } from "modules/Services";
import {
  CAS_EXTERNAL_USER_MODULE_NAME,
  SNP_EXTERNAL_USER_MODULE_NAME,
} from "Projects/Constants/stringConstants";
import {
  getIconObject,
  getOutlinedIconObject,
} from "Course/routes/Settings/modules/SettingsUtils";
import { isURL, parseConfigurationValue } from "Utils";
import {
  ENABLE_CAS_EXTERNAL_SUPERVISOR,
  ENABLE_PLANNER_ELEMENT_TRANSLATION_CONFIGURATION,
  ADMIN_PORTAL_ACCESS_PERMISSION,
  PROGRAMME_WIDE_CONFIGURATIONS_ACCESS_PERMISSION,
  ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION,
  ENABLE_ROLES_AND_PERMISSIONS_CONFIGURATION,
  ENABLE_AY_TRANSITION,
  ENABLE_PROGRAM_ROLES_FOR_INTEGRATIONS,
  CAN_CARRY_OUT_AYT_PERMISSION,
} from "Constants/permissionConstants";
import update from "immutability-helper";
import ACLStorage from "lib/aclService";
import { getIsGradingPeriodUnlocked } from "GradingSetup/modules/Utils";
import {
  getAdminPortalNodeVisibilityStatus,
  checkSchoolRosterIndividualLevelVisibilityWithCurriculumPrograms,
  checkIntegrationsIndividualLevelVisibilityWithCurriculumPrograms,
} from "Administrator/modules/RolesAndPermissionUtils";
import { Sentry } from "services/sentry";
import { getIsLearningCoursesEnabled } from "LearningCourses/modules/Utils";
import { checkIsSentralFeatureEnabledInCurriculum } from "Login/components/SentralPortalModal/SentralPortalUtils";
import { getIsAccountConfigurationEnabled } from "Utils/ACLStoreUtils";

let store;
import("store/createStore").then(importedModule => {
  store = importedModule.store;
});

export const canCarryOutAcademicYearTransitionForAccount = () => {
  return ACLStorage.getPermissionValue(CAN_CARRY_OUT_AYT_PERMISSION);
};

export const getCurriculumProgramTypeFromId = ({
  curriculumPrograms,
  curriculumProgramId,
}) => {
  const curriculumProgramType = _.get(
    _.find(curriculumPrograms, { id: curriculumProgramId }),
    "type"
  );
  return curriculumProgramType;
};

const DEFAULT_ICON_URL =
  "https://cloud.toddleapp.com/assets/subject-icons/SubjectGenericDuotone.svg";

// Add all the nodeIds of both cards or internal sidebar components
// here, And they will be hidden if surfing outside the current academic year
export const RESTRICTED_NODES_OUTSIDE_CURRENT_ACADEMIC_YEAR = [
  "CIRCULARS",
  "SCHOOL_ANALYTICS",
  "SUBJECT_SUMMARY",
  "CHECKLIST",
  "DP_IBIS_EXAM_REGISTRATION",
  "DP_IBIS_REGISTRATION",
  "DP_IB_E_COURSEWORK",
  "INTEGRATION_SETTINGS",
  "STAFF_PERMISSIONS",
  "ACTIVITY_LOGS",
  "TURNITIN_SETTINGS",
  "CHECKLIST_V2",
  "ACTIVITY_LOGS_V2",
];

export const RESTRICTED_NODES_FROM_FUTURE_ACADEMIC_YEAR = [
  "BEHAVIOUR_MANAGEMENT",
];

export const ADMIN_SEARCH_TEXT_FIELDS = {
  student: ["EMAIL", "NAME", "SOURCED_ID"],
  staff: ["EMAIL", "NAME"],
  visitor: ["EMAIL", "NAME"],
  family: ["EMAIL", "NAME"],
};

export const ACADEMIC_SETUP_SUBJECTS_SUBTEXT_STYLES = {
  fontSize: "1.6rem",
  color: colors.neutral200,
  marginTop: 0,
  ...fontStyle.demiBold,
};

export const INTEGRATION_NODES_ALLOWED_FOR_PROGRAM_LEVEL_ROLES = [
  "SYNCV2",
  "TIMETABLE_SYNC",
  "ATTENDANCE_SYNC",
  "ASSESSMENT_SYNC",
  "GRADEBOOK_SYNC",
];

export const getAdminSetupFiltersByEntityType = ({
  type,
  courses = [],
  accountAclRoles = [],
  programAclRoles = [],
  showOnlyResultsWithNoProgramACLRoles = false,
  searchText = "",
  templateType,
  curriculumProgramId,
  curriculumProgramIds,
  archivalState,
  designations,
  showOnlyResultsWithNoAssignedClasses,
  searchTextFields,
  grades,
  subjects,
  excludedTeacherIds,
  excludedStudentIds,
  subjectGroups,
  excludedCourseIds,
  excludedStaffIds,
  tags = [],
  yearGroups = [],
  levels = [],
  responseLanguages = [],
  homeroomFilters = {},
  academicYearId,
  academicYearIds,
  excludedGrades,
  roles,
  blockStatus,
  gender,
  firstNationality,
  secondNationality,
  firstLanguage,
  learningCourse = [],
  staff = [],
  createdBy = [],
}) => {
  switch (type) {
    case "SUBJECT":
      return {
        curriculumProgramIds: curriculumProgramId ? [curriculumProgramId] : [],
        searchText,
        grades,
        tags,
        archivalState,
        levels,
        responseLanguages,
      };
    case "GRADE":
    case "SUBJECT_GROUP":
    case "YEAR_GROUPS":
      return {
        curriculumProgramIds: curriculumProgramId
          ? _.isArray(curriculumProgramId)
            ? curriculumProgramId
            : [curriculumProgramId]
          : [],
        academicYearId,
      };
    case "STUDENT":
      return {
        courses,
        searchText,
        ...(showOnlyResultsWithNoAssignedClasses
          ? { showOnlyResultsWithNoAssignedClasses: true }
          : {}),
        ...(curriculumProgramIds
          ? { curriculumProgramIds }
          : curriculumProgramId
          ? { curriculumProgramIds: [curriculumProgramId] }
          : { curriculumProgramIds: [] }),
        archivalState,
        searchTextFields,
        excludedCourseIds,
        excludedStudentIds,
        grades,
        yearGroups,
        ...(!_.isEmpty(homeroomFilters) && { homeroomFilters }),
        ...(academicYearId ? { academicYearId } : {}),
        ...(academicYearIds ? { academicYearIds } : {}),
        excludedGrades,
        blockStatus,
        gender,
        firstNationality,
        secondNationality,
        firstLanguage,
      };
    case "STAFF":
      return {
        courses,
        accountAclRoles,
        programAclRoles,
        showOnlyResultsWithNoProgramACLRoles,
        searchText,
        designations,
        ...(showOnlyResultsWithNoAssignedClasses
          ? { showOnlyResultsWithNoAssignedClasses: true }
          : {}),
        ...(curriculumProgramIds
          ? { curriculumProgramIds }
          : curriculumProgramId
          ? { curriculumProgramIds: [curriculumProgramId] }
          : { curriculumProgramIds: [] }),
        archivalState,
        searchTextFields,
        includeSupportUser: false,
        ...(academicYearIds
          ? { academicYearIds }
          : academicYearId
          ? { academicYearIds: [academicYearId] }
          : {}),
      };
    // case "LEARNING_COURSE":
    case "COURSE":
      return {
        searchText,
        designations,
        archivalState,
        curriculumProgramIds: curriculumProgramId
          ? _.isArray(curriculumProgramId)
            ? curriculumProgramId
            : [curriculumProgramId]
          : [],
        grades,
        subjects,
        excludedTeacherIds,
        excludedStudentIds,
        subjectGroups,
        excludedCourseIds,
        excludedStaffIds,
        ...(academicYearIds
          ? { academicYears: academicYearIds }
          : academicYearId
          ? { academicYears: [academicYearId] }
          : {}),
        excludedGrades,
        roles,
        ...(!_.isEmpty(learningCourse) && {
          includedLearningCourseIds: learningCourse,
        }),
        ...(!_.isEmpty(staff) && { includedTeacherIds: staff }),
        ...(!_.isEmpty(createdBy) && { createdByIds: createdBy }),
      };
    case "LEARNING_COURSE":
      return {
        searchText,
        designations,
        archivalState,
        grades,
        subjects,
        excludedTeacherIds,
        excludedStudentIds,
        subjectGroups,
        excludedCourseIds,
        excludedStaffIds,
        ...(academicYearId ? { academicYears: [academicYearId] } : {}),
        excludedGrades,
        roles,
      };
    case "TEMPLATE":
      return {
        templateType: _.isNull(templateType) ? [] : [templateType],
        curriculumProgramIds: curriculumProgramId ? [curriculumProgramId] : [],
      };
    case "VISITOR_SETUP":
      return {
        searchText,
        roles: ["visitor"],
        archivalState,
        searchTextFields: ADMIN_SEARCH_TEXT_FIELDS["visitor"],
        moduleNames: ACLStore.can(ENABLE_CAS_EXTERNAL_SUPERVISOR)
          ? [SNP_EXTERNAL_USER_MODULE_NAME]
          : undefined,
      };
    case "SUBJECT_VARIANT":
      return {
        archivalState,
        levels,
        responseLanguages,
      };
    case "CAS_EXTERNAL_SUPERVISOR_SETUP":
      return {
        searchText,
        archivalState,
        searchTextFields: ADMIN_SEARCH_TEXT_FIELDS["visitor"],
        roles: [ROLE_VISITOR],
        moduleNames: [CAS_EXTERNAL_USER_MODULE_NAME],
      };
  }
};

export const getAdminSetupFiltersByEntityTypeMemoized = _.memoize(
  params => getAdminSetupFiltersByEntityType(params),
  params => JSON.stringify(params)
);

export const getAreGradingPeriodsLocked = gradingPeriods => {
  return _.some(gradingPeriods, period => !getIsGradingPeriodUnlocked(period));
};

export const getAssessmentToolFilters = ({ curriculumProgramId }) => {
  const filters = {
    curriculumProgramIds: [curriculumProgramId],
    orderBy: "CREATED_AT",
    orderByDirection: "DESC",
  };
  return filters;
};

const getUpdatedAdminMenuItems = ({ adminMenuItems, organizationId, t }) => {
  const { nodes } = adminMenuItems;

  const snpLabelSetting = getSettingValue({
    organizationId,
    name: "AppSettingSnpModuleLabel",
  });

  const updatedNodes = _.map(nodes, node => {
    const { id } = node;

    if (_.includes(id, "SNP")) {
      const label = t(`snp:${snpLabelSetting}`, {
        defaultValue: snpLabelSetting,
      });

      node.label = label;
      node.skipLocalization = true;
    }
    return node;
  });

  return { ...adminMenuItems, nodes: updatedNodes };
};

export const getUpdatedAdminMenuItemsMemoized = _.memoize(
  getUpdatedAdminMenuItems,
  ({ adminMenuItems, organizationId, language }) => {
    return JSON.stringify({
      adminMenuItems: _.map(adminMenuItems?.nodes, "id"),
      organizationId,
      language,
    });
  }
);

const getAdminMenuItems = () => {
  const userInfo = getUserInfo();
  const curriculumProgramsObj = getOrganizationCurriculumProgramsFromCache(
    _.get(userInfo, "org_id")
  );
  const curriculumPrograms = _.get(
    curriculumProgramsObj,
    "curriculumPrograms",
    []
  );

  const paidCurriculumPrograms = getPaidCurriculumPrograms({
    curriculumPrograms,
  });
  if (_.isEmpty(paidCurriculumPrograms)) return [];

  const curriculumConfigMap = getAllCurriculumsAdminConfigurationsObject({
    curriculumProgramList: curriculumPrograms,
  });

  const adminMenuItems = parseMenuItems({
    curriculumPrograms: paidCurriculumPrograms,
    curriculumConfigMap,
  });

  return adminMenuItems;
};

export const getAdminMenuItemsMemoize = _.memoize(
  params => getAdminMenuItems(params),
  params => JSON.stringify(params)
);

const getUpdatedLabelForCurriculum = ({
  item,
  currentCurriculumProgramType,
}) => {
  switch (currentCurriculumProgramType) {
    case CURRICULUM_TYPE_MYP: {
      if (item.id == "PROJECT_SETTING" || item.id === "PROJECT_SETTING_V2")
        return "common:projects";
      return item.sidebarLabel || item.label;
    }

    default: {
      return item.sidebarLabel || item.label;
    }
  }
};

export const getItemLabel = ({
  item,
  plannerElementSets,
  t,
  customMenuItemLabelsMap = {},
  currentCurriculumProgramType,
}) => {
  if (!item) return "";

  const itemId = _.get(item, "id");
  const customLabel = _.get(customMenuItemLabelsMap, `${itemId}`);

  if (customLabel) {
    return customLabel;
  }

  const defaultLabel = getUpdatedLabelForCurriculum({
    item,
    currentCurriculumProgramType,
  });

  const localeKeys = _.reduce(
    _.get(item, "locale_keys"),
    (result, val, key) => {
      result[key] = t(val, { defaultValue: val });
      return result;
    },
    {}
  );

  const defaultLocalizedLabel = t(defaultLabel, {
    ...localeKeys,
    defaultValue: defaultLabel,
  });

  const label = item.isDynamicPlannerElementLabel
    ? _.get(
        plannerElementSets,
        `${item.plannerElementType}.label`,
        defaultLocalizedLabel
      )
    : defaultLocalizedLabel;

  return label;
};

const _shouldSkipNodeInPermissionCalculation = ({ item }) => {
  const { uid } = item;

  if (
    ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION) &&
    _.find(
      RNP_INTEGRATED_NODES,
      rnpNodeId => _.includes(uid, rnpNodeId) || uid === rnpNodeId
    )
  ) {
    return true;
  }

  return false;
};

const getPermissions = ({
  item,
  nodes,
  excludeChildrenForRnPNodes = false,
}) => {
  let permissions = [];
  const itemPerm = _.get(item, "perm");
  const checkOnlyForParentPermission = _.get(
    item,
    "checkOnlyForParentPermission"
  );

  if (!_shouldSkipNodeInPermissionCalculation({ item })) {
    if (_.isArray(itemPerm)) {
      permissions.push(...itemPerm);
    } else if (itemPerm) {
      permissions.push(itemPerm);
    }
  }
  //applied this check to avoid recursion for checking child permissions
  //we will show whole menu if parent has this permission
  if (checkOnlyForParentPermission) return permissions;

  const children = _.get(item, "children", []);
  _.forEach(children, childId => {
    const nodeItem = _.find(nodes, { uid: childId });

    const nodeChildren = _.get(nodeItem, "children", []);
    const hasChildren = _.size(nodeChildren) !== 0;
    const nodePerm = _.get(nodeItem, "perm", "");
    const hasPerms = nodeItem && nodePerm;
    const excludeChildren =
      excludeChildrenForRnPNodes && _.get(nodeItem, "permission", "");

    if (
      hasPerms &&
      !_shouldSkipNodeInPermissionCalculation({ item: nodeItem })
    ) {
      permissions.push(nodePerm);
    }
    if (hasChildren && !excludeChildren) {
      const childPermissions = getPermissions({
        item: nodeItem,
        nodes,
        excludeChildrenForRnPNodes,
      });
      permissions = [...permissions, ...childPermissions];
    }
  });
  return permissions;
};

export const getPermissionsMemoize = _.memoize(
  params => getPermissions(params),
  ({ item, nodes }) =>
    JSON.stringify({ item: item?.id, nodes: _.map(nodes, "id") })
);

export const validateForm = ({ formDetails, requiredFields = [] }) => {
  let totalCount = 0;
  const newErrors = {};

  _.forOwn(formDetails, (value, key) => {
    const isError = _.isEmpty(value) && _.includes(requiredFields, key);
    newErrors[key] = isError;
    totalCount += isError;
  });
  return { totalCount, newErrors };
};

export const getSelectedOptionsLabels = ({ options, value }) => {
  const selectedOptionsLabels = _.map(
    _.filter(options, item => _.includes(value, item.value)),
    option => option.label
  );

  return selectedOptionsLabels;
};

const _getSelectedCurriculumObject = ({ selectedCurriculum }) => {
  const isSelected = curriculum => _.isEqual(curriculum, selectedCurriculum);

  const isPYP = isSelected(CURRICULUM_TYPE_PYP);
  const isMYP = isSelected(CURRICULUM_TYPE_MYP);
  const isUBD = isSelected(CURRICULUM_TYPE_UBD);
  const isDP = isSelected(CURRICULUM_TYPE_DP);

  return { isPYP, isMYP, isUBD, isDP };
};

export const getSelectedCurriculumObject = _.memoize(
  params => _getSelectedCurriculumObject(params),
  params => JSON.stringify(params)
);

export const parseAdminMenuId = id => {
  if (!id) return {};

  if (_.includes(id, ":")) {
    const [curriculumProgramId, nodeId] = _.split(id, ":");
    return { curriculumProgramId, nodeId };
  } else return { nodeId: id };
};

export const getAdminMenuUid = ({
  curriculumProgramId,
  nodeId,
  isDynamicNode,
}) => {
  const isDynamic = isDynamicNode || isDynamicAdminMenuNodeMemoize(nodeId);
  if (!isDynamic) return nodeId; // if its not a dynamic node, then the nodeId is the uid

  const parsed = parseAdminMenuId(nodeId);

  return curriculumProgramId
    ? `${curriculumProgramId}:${parsed.nodeId}`
    : parsed.nodeId;
};

export const removeIBPrefixFromCurriculumType = curriculumProgramType =>
  curriculumProgramType.replace("IB_", "");

const isDynamicAdminMenuNode = nodeId => {
  const { nodes: AdminMenuNodes } = AdminMenu;

  const nodes = AdminMenuNodes;

  const parsed = parseAdminMenuId(nodeId);

  const matchedNode = _.find(nodes, {
    id: parsed.nodeId,
  });

  return _.get(matchedNode, "isDynamicNode", false);
};

export const isDynamicAdminMenuNodeMemoize = _.memoize(isDynamicAdminMenuNode);

// If attendance has ADMIN_ACCESS, then show settings card
// and `Attendance Manager` tab inside it
const customSkipCheckForProgrammeSettings = ({ uid, curriculumIds }) => {
  // The nodes checked here are curriculum specific nodes
  // So expecting only single curriculum from curriculumIds
  const curriculumId = _.first(curriculumIds);

  const pypSettingsNodeId = getAdminMenuUid({
    curriculumProgramId: curriculumId,
    nodeId: "PYP_SETTINGS",
    isDynamicNode: true,
  });

  const mypSettingsNodeId = getAdminMenuUid({
    curriculumProgramId: curriculumId,
    nodeId: "MYP_SETTINGS",
    isDynamicNode: true,
  });

  const ubdSettingsNodeId = getAdminMenuUid({
    curriculumProgramId: curriculumId,
    nodeId: "UBD_SETTINGS",
    isDynamicNode: true,
  });

  const dpSettingsNodeId = getAdminMenuUid({
    curriculumProgramId: curriculumId,
    nodeId: "DP_SETTINGS",
    isDynamicNode: true,
  });

  switch (uid) {
    case pypSettingsNodeId:
    case mypSettingsNodeId:
    case ubdSettingsNodeId:
    case dpSettingsNodeId: {
      const hasAttendanceAdminAccess = getConfigurationAccess({
        curriculumIds,
        moduleKey: MODULES.ATTENDANCE.id,
      });

      if (hasAttendanceAdminAccess) {
        return true;
      }

      return false;
    }
    default:
      return false;
  }
};

/**
 * @description This function work like this for different kind of nodes:
 *              - For nodes that represents cards, staff access permission is checked for the node.
 *              - For nodes that represents collection of cards(Ex: School configurations, Curriculum configurations and Node for showing program related cards),
 *                staff access permission is checked for all the children nodes and if any of the children node has access, then the parent node is shown.
 */
export const getRolesAndPermissionAccessForNode = ({
  curriculumIds,
  uid,
  rootNode,
  childrenNodeIds,
  skipRolesAndPermissionsCheck,
  isSchoolAdmin,
  curriculumConfigMap,
}) => {
  const node = getAdminNode(uid);
  if (!rootNode && !node.isProgramRootNode) {
    return node && !skipRolesAndPermissionsCheck && !isSchoolAdmin
      ? getConfigurationAccess({
          curriculumIds,
          moduleKey: node.rolesAndPermissionKey || uid,
        })
      : true;
  }

  // When it is rootNode (CURRICULUM_CONFIGURATIONS / SCHOOL_CONFIGURATIONS) or programRootNode(indicated by isProgramRootNode),
  // check the children nodes value
  return _.some(childrenNodeIds, childrenNodeId => {
    const { nodeId, curriculumProgramId } = parseAdminMenuId(childrenNodeId);
    const childNode = getAdminNode(childrenNodeId);

    const {
      perm,
      rolesAndPermissionKey,
      skipRolesAndPermissionsCheck,
      skipForTeacher,
      permission: rnpPermission,
    } = getAdminNode(childrenNodeId);

    if (skipForTeacher && !isSchoolAdmin) return false;

    const enabledForAllUsers = !perm && !rnpPermission;
    const perms = perm ? (_.isArray(perm) ? perm : [perm]) : [];

    let isPermitted;
    if (curriculumProgramId) {
      isPermitted = !enabledForAllUsers
        ? _.some(perms, permission => {
            return (
              _.get(curriculumConfigMap, [
                curriculumProgramId,
                permission,
                "value",
              ]) === "true"
            );
          })
        : true;
    } else {
      isPermitted = !enabledForAllUsers ? ACLStore.can(perms) : true;
    }

    if (childNode && !isSchoolAdmin) {
      if (!skipRolesAndPermissionsCheck) {
        return (
          isPermitted &&
          getConfigurationAccess({
            curriculumIds,
            moduleKey: rolesAndPermissionKey || nodeId,
          })
        );
      } else {
        return isPermitted;
      }
    }
    return true;
  });
};

export const getModuleNameFromUid = uid => {
  const { nodeId } = parseAdminMenuId(uid);
  return nodeId;
};

export const getRestrictedModulesForSelectedAcademicYear = () => {
  return RESTRICTED_NODES_OUTSIDE_CURRENT_ACADEMIC_YEAR;
};

export const checkForAcademicYearRestriction = ({
  moduleName,
  isFutureAcademicYearSelected,
}) => {
  const isRestrictedToCurrentAcademicYear = _.includes(
    getRestrictedModulesForSelectedAcademicYear(),
    moduleName
  );

  if (isRestrictedToCurrentAcademicYear) {
    return true;
  }

  return (
    isFutureAcademicYearSelected &&
    _.includes(RESTRICTED_NODES_FROM_FUTURE_ACADEMIC_YEAR, moduleName)
  );
};

/**
 * List of nodes that are fully integrated with the new Roles and Permissions (RNP) control parameters.
 * For these nodes, the old visibility logic is skipped, and node visibility is determined solely by the new `isNodeVisible` function.
 * Example nodes include SCHOOL_SETUP, SCHOOL_SETTINGS_MODULE, and program-specific settings such as PYP_SETTINGS, MYP_SETTINGS, etc.
 */
const RNP_INTEGRATED_NODES = [
  "SCHOOL_SETUP",
  "SCHOOL_SETTINGS_MODULE",
  "PYP_SETTINGS",
  "MYP_SETTINGS",
  "UBD_SETTINGS",
  "DP_SETTINGS",
  "ATTENDANCE_SETTINGS_V2",
  "ATTENDANCE_SETTINGS",
  "PYP_TIMETABLE",
  "MYP_TIMETABLE",
  "UBD_TIMETABLE",
  "DP_TIMETABLE",
  "PERIODS_SETUP",
  "PYP_ATTENDANCE_DASHBOARD",
  "MYP_ATTENDANCE_DASHBOARD",
  "UBD_ATTENDANCE_DASHBOARD",
  "DP_ATTENDANCE_DASHBOARD",
  "CIRCULARS",
  "PYP_ACADEMIC_SETUP",
  "MYP_ACADEMIC_SETUP",
  "UBD_ACADEMIC_SETUP",
  "DP_ACADEMIC_SETUP",
  "BEHAVIOUR_MANAGEMENT",
  "ACADEMY_ANALYTICS",
  "BEHAVIOUR_CONFIGURATION",
  "TRASH_LEARNING_COURSES",
  "PYP_ATTENDANCE_AND_TIMETABLE_SETTINGS",
  "MYP_ATTENDANCE_AND_TIMETABLE_SETTINGS",
  "UBD_ATTENDANCE_AND_TIMETABLE_SETTINGS",
  "DP_ATTENDANCE_AND_TIMETABLE_SETTINGS",
];

const checkIsSentralFeatureDisabled = (
  feature,
  curriculumConfigMap,
  curriculumProgramId
) => {
  const isSentralFeatureEnabled = checkIsSentralFeatureEnabledInCurriculum(
    feature,
    curriculumConfigMap,
    curriculumProgramId
  );

  return !isSentralFeatureEnabled;
};

/**
 * @description This function returns whether node(represented by uid) is visible or not. It works like this:
 *              - It takes permissions of all descendants of the node and checks whether any of the permission is enabled or not.
 *              - It performs academic year related checks and hide/show certain nodes(shown as cards on UI)
 *              - It performs staff access permission based checks based on the type of node(Card or collection of cards)
 */
export const validatePermission = ({
  curriculumConfigMap,
  permissions,
  uid,
  rootNode,
  childrenNodeIds,
  skipRolesAndPermissionsCheck = false,
  isCurrentAcademicYearSelected,
  isFutureAcademicYearSelected,
  customPermValidator,
  checkConfigEnableInAnyCurriculum = false,
  sentralPortalDisablityFeatureFlag,
  curriculumProgramIds,
}) => {
  const { curriculumProgramId, nodeId } = parseAdminMenuId(uid);
  /**
   * This condition ensures that the function is not executed for nodes where RNP (Roles and Permissions) integration is already completed.
   * We cannot remove this function entirely for backward compatibility, nor can we can put this function on rnp consumption permission,
   * as some modules are still in progress with RNP integration.
   */
  if (
    ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION) &&
    _.find(
      RNP_INTEGRATED_NODES,
      rnpNodeId => _.includes(nodeId, rnpNodeId) || nodeId === rnpNodeId
    )
  ) {
    return false;
  }
  //Here, all perms of the node and its children nodes are checked.
  let configurationPermissionAccess = ACLStore.can(permissions);
  const moduleName = getModuleNameFromUid(uid);

  // Checking for module access outside of current academic year
  const accessibleOutsideCurrentAcademicYear = !isCurrentAcademicYearSelected
    ? rootNode ||
      !checkForAcademicYearRestriction({
        moduleName,
        isFutureAcademicYearSelected,
      })
    : true;

  if (curriculumProgramId) {
    //Here, for modules that are at program level, permission value is checked.
    configurationPermissionAccess = _.some(
      permissions,
      perm =>
        _.get(curriculumConfigMap, [curriculumProgramId, perm, "value"]) ===
        "true"
    );
  }

  if (checkConfigEnableInAnyCurriculum) {
    configurationPermissionAccess = _.some(permissions, perm => {
      return _.some(
        _.values(curriculumConfigMap),
        config => _.get(config, [perm, "value"]) === "true"
      );
    });
  }

  if (customPermValidator) {
    //Dynamic logic for checking permissions
    configurationPermissionAccess = customPermValidator({
      permissions,
      curriculumConfigMap,
      curriculumProgramIds,
    });
  }

  const isSchoolAdmin = getIsAdminByRole();

  const curriculumIds = curriculumProgramId
    ? [curriculumProgramId]
    : _.keys(curriculumConfigMap);

  skipRolesAndPermissionsCheck =
    skipRolesAndPermissionsCheck ||
    //Applicable for settings only
    customSkipCheckForProgrammeSettings({ uid, curriculumIds });

  return (
    accessibleOutsideCurrentAcademicYear &&
    configurationPermissionAccess &&
    getRolesAndPermissionAccessForNode({
      curriculumIds,
      uid,
      rootNode,
      childrenNodeIds,
      skipRolesAndPermissionsCheck,
      isSchoolAdmin,
      curriculumConfigMap,
    }) &&
    (sentralPortalDisablityFeatureFlag
      ? checkIsSentralFeatureDisabled(
          sentralPortalDisablityFeatureFlag,
          curriculumConfigMap,
          curriculumProgramId
        )
      : true)
  );
};

export const getCountryDropdownDataMemoize = _.memoize(
  params => getCountryOptions(params),
  params => JSON.stringify(params)
);

export const getOptions = ({ items, shouldCapitalizeLabel = false }) => {
  return _.map(items, ({ name, id, value }) => {
    const label = name || value;
    return {
      label: shouldCapitalizeLabel ? _.capitalize(label) : label,
      value: id,
    };
  });
};

export const getSidebarMenuTreeStructure = ({
  menuId,
  t,
  nodes,
  plannerElementSets,
  parent,
  customMenuItemLabelsMap,
  organizationCurriculumProgramTypes,
  curriculumProgramId,
  readFromUserAndOrgLevel = false,
  isCurrentAcademicYearSelected,
  isFutureAcademicYearSelected,
  selectedCurriculumProgramType,
  curriculumProgramIds,
}) => {
  let item = getAdminNodesWithUpdatedChildren(menuId, curriculumProgramId);

  if (
    (!isCurrentAcademicYearSelected &&
      _.includes(RESTRICTED_NODES_OUTSIDE_CURRENT_ACADEMIC_YEAR, menuId)) ||
    (isFutureAcademicYearSelected &&
      _.includes(menuId, "GRADING_PERIODS") &&
      menuId !== "GRADING_PERIODS")
  ) {
    item = {};
  }

  if (_.isEmpty(item)) {
    return {
      nodes: [],
    };
  }

  const {
    uid: key,
    children,
    hasSubTabs = false,
    perm,
    isPermNegated = false,
    levelId,
    curriculumPrograms,
    suffix,
    shouldHideForOtherCurriculums,
    isSubsection = false,
    isSubsectionInsideSubTab = false,
    subtext,
  } = item;

  let maxDepth = 0;
  let currentNodes = [];
  const filteredChildren = [];

  _.forEach(children, childId => {
    const { depth, nodes: menuNodes } = getSidebarMenuTreeStructure({
      menuId: childId,
      t,
      nodes,
      plannerElementSets,
      parent: levelId === "L1" ? "root" : key,
      customMenuItemLabelsMap,
      curriculumProgramId,
      readFromUserAndOrgLevel,
      isCurrentAcademicYearSelected,
      isFutureAcademicYearSelected,
      selectedCurriculumProgramType,
      curriculumProgramIds,
    });

    maxDepth = _.max([depth, maxDepth]);
    currentNodes = [...currentNodes, ...menuNodes];

    const childNode = _.find(currentNodes, { key: childId });

    const isChildPresentInList = !_.isEmpty(childNode);

    const intersectionArray = _.intersection(
      childNode?.curriculumPrograms,
      organizationCurriculumProgramTypes
    );

    let showChild =
      _.isEmpty(childNode?.curriculumPrograms) ||
      _.isEmpty(organizationCurriculumProgramTypes)
        ? true
        : !_.isEmpty(intersectionArray);

    if (
      (_.isEqual(childNode?.key, "PROJECT_SETTING") ||
        _.isEqual(childNode?.key, "PROJECT_SETTING_V2") ||
        _.isEqual(childNode?.key, "SAA_REFLECTION_QUESTIONS")) &&
      childNode?.shouldHideForOtherCurriculums
    ) {
      showChild =
        showChild &&
        _.includes(
          childNode?.curriculumPrograms,
          selectedCurriculumProgramType
        );
    }

    if (isChildPresentInList && showChild) {
      filteredChildren.push(childId);
    }
  });

  const title = getItemLabel({
    item,
    plannerElementSets,
    t,
    customMenuItemLabelsMap,
    currentCurriculumProgramType: selectedCurriculumProgramType,
  });

  const permissions = getPermissionsMemoize({
    item,
    nodes,
  });

  const isNodeVisible = getAdminPortalNodeVisibilityStatus({
    item,
    nodes,
    curriculumProgramId,
    curriculumProgramIds,
    isCurrentAcademicYearSelected,
  });

  let finalPerm = perm;

  if (_shouldSkipNodeInPermissionCalculation({ item })) {
    finalPerm = "";
  }

  const hasChildren = !_.isEmpty(filteredChildren);
  const isParentMenu = hasChildren && !hasSubTabs;
  const isPermitted =
    ACLStore.can(
      isParentMenu ? permissions : finalPerm,
      undefined,
      readFromUserAndOrgLevel
    ) || isNodeVisible;

  const subMenuWithNoChildren = !hasChildren && (hasSubTabs || isSubsection);
  if ((isPermNegated ? !isPermitted : isPermitted) && !subMenuWithNoChildren) {
    const isDivider = _.get(item, "isDivider", false);
    const node =
      levelId === "L1"
        ? {
            key: "root",
            children: filteredChildren,
          }
        : {
            key,
            title: levelId !== "L1" ? title : null,
            children: filteredChildren,
            isSliderSubmenu: hasSubTabs,
            isSubsectionInsideSubTab,
            tier: maxDepth + 1,
            parent,
            curriculumPrograms,
            shouldHideForOtherCurriculums,
            subtext: t(subtext),
            ...(isDivider ? { isDivider } : {}),
            suffix,
          };
    currentNodes.push(node);
  }
  return {
    nodes: currentNodes,
    depth: hasSubTabs ? 1 : maxDepth + 1,
  };
};

const getSelectedTitle = ({ nodes }) => {
  const L1Nodes = _.filter(nodes, ({ levelId }) => levelId === "L1");
  const pathName = window.location.pathname;
  const selectedTitle = _.head(
    _.filter(L1Nodes, ({ route }) => _.includes(pathName, route))
  );
  return selectedTitle;
};

export const getSelectedTitleMemoize = _.memoize(
  params => getSelectedTitle(params),
  params => JSON.stringify(params)
);

export const isBulkUploadFlowEnabled = () =>
  ACLStore.can("FeatureFlag:EnableNewBulkUploadFlow");

export const checkIsfilterApplied = filters => {
  return _.reduce(
    filters,
    (result, filter, key) => {
      if (_.isEqual(key, "archivalState")) {
        return result || _.isEqual(filter, "ARCHIVED");
      }
      return result || !_.isEmpty(filter);
    },
    false
  );
};

const getStaffPermissionFeedMetadata = node => {
  const { id, parent, route } = node;
  if (parent === "TEACHER_PERMISSIONS") {
    return {
      feedKey: "TEACHERS",
      curriculumProgramId: route,
    };
  }
  if (id === "SCHOOL_ADMIN_PERMISSION") {
    return {
      feedKey: "ADMINISTRATOR",
    };
  }
};

const getStaffPermissionFeedDiff = ({ feedKey, curriculumProgramId }) => {
  const state = store?.getState() ?? {};
  const MODULE_KEY = "staffPermissions";
  if (feedKey === "TEACHERS") {
    return _.get(state, [MODULE_KEY, "diff", feedKey, curriculumProgramId], []);
  }
  return _.get(state, [MODULE_KEY, "diff", feedKey]);
};

export const getStaffPermissionSideBarNodeOnLeaveInterceptor = ({ node }) => {
  return ({ destinationNode, source }) => {
    const { feedKey, curriculumProgramId } = getStaffPermissionFeedMetadata(
      node
    );
    const diff = getStaffPermissionFeedDiff({ feedKey, curriculumProgramId });
    const allowNavigation = _.isEmpty(diff);

    if (!allowNavigation) {
      const dispatch = store?.dispatch;
      dispatch({
        type: "SET_DISCARD_DIALOG staffPermissions", // defined in StaffPermissionModule.js
        data: {
          feedKey,
          curriculumProgramId,
          onDiscardConfirm: () => {
            if (source === "SIDEBAR_MENU") {
              const t = i18next.t;
              dispatch(
                handleAdminSidebarMenuItemClick({ t, key: destinationNode.uid })
              );
              return;
            }
            if (source === "SIDEBAR_BACK") {
              dispatch(handleAdminSidebarBackButtonClick());
              return;
            }
          },
        },
      });
    }

    return allowNavigation;
  };
};

export const getSubjectErrorMsgFromWarning = ({ warning, t }) => {
  const code = _.get(warning, "code");
  switch (code) {
    case "TD/UPSSUB/001":
      return t("academicSetup:subject_name_already_exists_error_msg");
    default:
      return t("toastMsgs:something_went_wrong");
  }
};

const getModuleConfig = ({ configurations }) => {
  const curriculumId = _.split(_.get(configurations, "0.uidV2", ""), "::")[1];

  if (!curriculumId) return {};

  const state = store?.getState() ?? {};
  const orgCurriculumPrograms = getOrganizationCurriculumPrograms(state);

  Sentry.addBreadcrumb({
    category: "getModuleConfig",
    level: "debug",
    message: JSON.stringify({
      orgCurriculumPrograms,
      curriculumId,
    }),
  });

  const curriculumProgram = _.find(orgCurriculumPrograms, {
    id: curriculumId,
  });

  if (!curriculumProgram) return {};

  const { type: curriculumType } = curriculumProgram;
  const curriculumModules =
    CURRICULUM_MODULE_MAP[curriculumType]?.modules || [];
  const moduleColumnsData = {};

  _.forEach(configurations, config => {
    const moduleId = _.findKey(
      MODULE_CONFIGURATION_MAP,
      configValue => configValue == config.configuration
    );

    if (!moduleId) return;

    if (!_.includes(curriculumModules, moduleId)) return;

    moduleColumnsData[moduleId] = parseConfigurationValue(config);
  });

  return { curriculumId, moduleColumnsData };
};

export const getStaffModulesConfiguration = () => {
  const state = store?.getState() ?? {};
  const curriculumWiseModuleAccess = {};
  const userCurriculumPrograms = getUserCurriculumPrograms(state);

  const configurationVariable = generateConfigurationQueryVariables({
    src: "TEACHER_PERMISSION",
    curriculumProgramList: userCurriculumPrograms,
  });

  const configurationsResponse = getConfigurationsFromCacheV2(
    configurationVariable
  );

  _.forEach(configurationsResponse, configurationResponse => {
    const { curriculumId, moduleColumnsData } = getModuleConfig(
      configurationResponse
    );
    curriculumWiseModuleAccess[curriculumId] = moduleColumnsData;
  });

  return curriculumWiseModuleAccess;
};

export const CURRICULUM_MODULE_ACCESS_RULE = {
  ACADEMIC_SETUP: {
    canAccessAcademicSetup: {
      rule: "eq",
      value: "ADMIN_ACCESS",
      defaultAccess: false,
      defaultAccessForUserBeingAdmin: true,
    },
  },
  EVALUATION_CYCLES: {
    canAccessEvaluationCycles: {
      rule: "eq",
      value: "ADMIN_ACCESS",
      defaultAccess: false,
      defaultAccessForUserBeingAdmin: true,
    },
  },
  IBIS_REGISTRATION: {
    canAccessIBISRegistration: {
      rule: "eq",
      value: "ADMIN_ACCESS",
      defaultAccess: false,
      defaultAccessForUserBeingAdmin: true,
    },
  },
  IB_ECOURSEWORK: {
    canAccessIBISRegistration: {
      rule: "eq",
      value: "ADMIN_ACCESS",
      defaultAccess: false,
      defaultAccessForUserBeingAdmin: true,
    },
  },
  CLASS_SUMMARY: {
    canAccessClassSummary: {
      rule: "eq",
      value: "ADMIN_ACCESS",
      defaultAccess: false,
      defaultAccessForUserBeingAdmin: true,
    },
  },
  EDUCATOR_CENTER: {
    canAccessEducatorCenter: {
      rule: "eq",
      value: "ADMIN_ACCESS",
      defaultAccess: false,
      defaultAccessForUserBeingAdmin: true,
    },
  },
  PROGRESS_REPORTS: {
    canAccessProgressReport: {
      rule: "eq",
      value: "ADMIN_ACCESS",
      defaultAccess: false,
      defaultAccessForUserBeingAdmin: true,
    },
  },
  UNIT_PLANNING: {
    canAccessUnitPlanning: {
      rule: "eq",
      value: "ADMIN_ACCESS",
      defaultAccess: false,
      defaultAccessForUserBeingAdmin: true,
    },
  },
  ATTENDANCE: {
    canAccessAttendance: {
      rule: "eq",
      value: "ADMIN_ACCESS",
      defaultAccess: false,
      defaultAccessForUserBeingAdmin: true,
    },
  },

  PLANNING_INSIGHTS: {
    canAccessPlanningInsights: {
      rule: "eq",
      value: "ADMIN_ACCESS",
      defaultAccess: false,
      defaultAccessForUserBeingAdmin: true,
    },
  },
  CURRICULUM_SETTINGS: {
    canAccessCurriculumSetting: {
      rule: "eq",
      value: "ADMIN_ACCESS",
      defaultAccess: false,
      defaultAccessForUserBeingAdmin: true,
    },
  },
  QUESTION_LIBRARY: {
    canAccessQuestionLibrary: {
      rule: "gte",
      value: "CREATOR_ACCESS",
      defaultAccess: false,
      defaultAccessForUserBeingAdmin: true,
    },
  },
  GRADEBOOK: {
    canAccessGradebook: {
      rule: "eq",
      value: "ADMIN_ACCESS",
      defaultAccess: false,
      defaultAccessForUserBeingAdmin: true,
    },
  },
};

export const SCHOOL_CONFIGURATION_MODULE_ACCESS_RULES = {
  SCHOOL_SETUP: {
    canAccessSchoolSetup: {
      rule: "eq",
      value: "ADMIN_ACCESS",
      defaultAccess: false,
      defaultAccessForUserBeingAdmin: true,
    },
  },
  SCHOOL_CALENDAR: {
    canAccessSchoolCalendar: {
      rule: "eq",
      value: "ADMIN_ACCESS",
      defaultAccess: false,
      defaultAccessForUserBeingAdmin: true,
    },
  },
  YEAR_GROUP_MANAGER: {
    canAccessYearGroupManager: {
      rule: "eq",
      value: "ADMIN_ACCESS",
      defaultAccess: false,
      defaultAccessForUserBeingAdmin: true,
    },
  },
  STAFF_PERMISSIONS: {
    canAccessStaffPermission: {
      rule: "eq",
      value: "ADMIN_ACCESS",
      defaultAccess: false,
      defaultAccessForUserBeingAdmin: true,
    },
  },
  ANNOUNCEMENTS: {
    canAccessAnnouncementPermission: {
      rule: "eq",
      value: "ADMIN_ACCESS",
      defaultAccess: false,
      defaultAccessForUserBeingAdmin: true,
    },
  },
  BEHAVIOUR_MANAGEMENT: {
    canAccessBehaviourManagement: {
      rule: "eq",
      value: "ADMIN_ACCESS",
      defaultAccess: false,
      defaultAccessForUserBeingAdmin: true,
    },
  },
  CURRICULUM_SETTINGS: {
    canAccessCurriculumSetting: {
      rule: "eq",
      value: "ADMIN_ACCESS",
      defaultAccess: false,
      defaultAccessForUserBeingAdmin: true,
    },
  },
};

const HOME_MODULE_ACCESS_RULE = {
  FAMILY_COMMUNICATION: {
    canAccessFamilyCommunication: {
      rule: "gt",
      value: "NO_ACCESS",
      defaultAccess: false,
    },
  },

  EVALUATION_CYCLES: {
    canAccessEvaluationCycles: {
      rule: "gt",
      value: "NO_ACCESS",
      defaultAccess: false,
    },
  },
  PROGRESS_REPORTS: {
    canAccessProgressReport: {
      rule: "gt",
      value: "NO_ACCESS",
      defaultAccess: true,
    },
  },
  STUDENT_PROFILE: {
    canAccessStudentProfile: {
      rule: "gt",
      value: "NO_ACCESS",
      defaultAccess: true,
    },
  },
  BEHAVIOUR_MANAGEMENT: {
    canAccessBehaviourManagement: {
      rule: "gte",
      value: "TEACHER_ACCESS",
      defaultAccess: true,
    },
  },
};

const ADMIN_MODULES_ACCESS_RULES = {
  ...CURRICULUM_MODULE_ACCESS_RULE,
  ...SCHOOL_CONFIGURATION_MODULE_ACCESS_RULES,
};

export const getConfigurationAccess = ({ curriculumIds, moduleKey }) => {
  return _.some(curriculumIds, curriculumId =>
    getConfigurationAccessForCurriculumAndModule({ curriculumId, moduleKey })
  );
};

export const getConfigurationAccessForCurriculumAndModule = ({
  curriculumId,
  moduleKey,
}) => {
  if (getIsAdminByRole()) {
    return true;
  }

  const module = ADMIN_MODULES_ACCESS_RULES[moduleKey];

  if (!module) {
    return false;
  }

  const staffModuleAccess = getStaffModulesConfiguration();
  const accessLevel = _.get(staffModuleAccess, curriculumId, null);

  if (!accessLevel) {
    return false;
  }

  const moduleAccess = accessLevel[moduleKey];
  if (!moduleAccess) return false;

  const accesses = getAccessLevels(
    { [moduleKey]: module },
    accessLevel[moduleKey],
    true
  );

  const hasAccess = _.some(_.values(accesses), access => !!access);
  return hasAccess;
};

const getCustomBlockAccess = ({ curriculumId, module }) =>
  curriculumId &&
  !getConfigurationAccessForCurriculumAndModule({
    curriculumId,
    moduleKey: module,
  });

export const getCustomBlockAccessMemoized = _.memoize(
  getCustomBlockAccess,
  JSON.stringify
);

export const getHomeModuleAccessCurriculumIds = ({ module, curriculumIds }) => {
  const curriculumWiseModuleAccess = getStaffModulesConfiguration();
  return _.reduce(
    curriculumIds,
    (result, curriculumId) => {
      const accessLevel = _.get(curriculumWiseModuleAccess, curriculumId, null);
      const moduleAccess = accessLevel?.[module];
      if (!moduleAccess) return result;
      const moduleRules = HOME_MODULE_ACCESS_RULE[module];
      const accessValues = getAccessLevels(
        { [module]: moduleRules },
        moduleAccess
      );
      const isEnabled = _.some(accessValues, _.truthy);
      if (isEnabled) {
        result.push(curriculumId);
      }
      return result;
    },
    []
  );
};

export const getAdminPanelModuleAccessCurriculumIds = ({
  module,
  curriculumIds,
}) => {
  const curriculumWiseModuleAccess = getStaffModulesConfiguration();
  return _.reduce(
    curriculumIds,
    (result, curriculumId) => {
      const accessLevel = _.get(curriculumWiseModuleAccess, curriculumId, null);
      const moduleAccess = accessLevel?.[module];
      if (!moduleAccess) return result;
      const moduleRules = ADMIN_MODULES_ACCESS_RULES[module];
      const accessValues = getAccessLevels(
        { [module]: moduleRules },
        moduleAccess
      );
      const isEnabled = _.some(accessValues, _.truthy);
      if (isEnabled) {
        result.push(curriculumId);
      }
      return result;
    },
    []
  );
};

export const getSchoolConfigurationAccessModule = curriculumId => {
  const curriculumWiseModuleAccess = getStaffModulesConfiguration();
  const accessLevel = _.get(curriculumWiseModuleAccess, curriculumId, null);

  if (!accessLevel) return false;

  const curriculumAccess = _.reduce(
    SCHOOL_CONFIGURATION_MODULE_ACCESS_RULES,
    (result, moduleRules, module) => {
      const moduleAccess = accessLevel[module];
      if (!moduleAccess) return result;

      const accessValues = getAccessLevels(
        { [module]: moduleRules },
        moduleAccess
      );
      const isEnabled = _.some(accessValues, _.truthy);
      if (isEnabled) {
        result[module] = accessValues;
      }
      return result;
    },
    {}
  );

  return curriculumAccess;
};

export const getPossibleCurriculumsForUser = ({
  organizationCurriculumPrograms,
  moduleKey,
}) => {
  if (!ACLStore.isStaffPermissionEnabled(moduleKey) || getIsAdminByRole()) {
    return organizationCurriculumPrograms;
  }

  const allCurriculumPrograms = _.filter(
    organizationCurriculumPrograms,
    curriculumProgram => {
      return getConfigurationAccessForCurriculumAndModule({
        curriculumId: _.get(curriculumProgram, "id"),
        moduleKey,
      });
    }
  );

  return allCurriculumPrograms;
};

export const ASSIGNMENT_STATE_ENUM = Object.freeze({
  Completed: "ARCHIVED",
  Ongoing: "PUBLISHED",
  Scheduled: "SCHEDULED",
  Draft: "DRAFT",
});

export const ASSIGNMENT_STATE_ENUM_LABELS = Object.freeze({
  PUBLISHED: "classRoom:to_review",
  ARCHIVED: "classRoom:reviewed",
  SCHEDULED: "common:scheduled",
  DRAFT: "common:draft",
});

export const ORGANIZATION_RESOURCE_STATES_ENUM = Object.freeze({
  Published: "PUBLISHED",
  Draft: "DRAFT",
});

export const ORGANIZATION_RESOURCE_STATES_ENUM_LABELS = Object.freeze({
  PUBLISHED: "common:shared",
  DRAFT: "common:draft",
});

export const sortSubjects = ({ subjects, orderByDirection }) => {
  return _.orderBy(
    subjects,
    ["isArchived", subject => _.toLower(_.get(subject, "name", ""))],
    ["asc", _.lowerCase(orderByDirection)]
  );
};

export const sortSubjectsInSubjectGroups = ({
  subjectGroups,
  orderByDirection,
}) => {
  let updatedSubjectGroups = [...subjectGroups];

  _.forEach(updatedSubjectGroups, (subjectGroup, index) => {
    const sortedSubjects = sortSubjects({
      subjects: _.get(subjectGroup, "subjects", []),
      orderByDirection,
    });

    updatedSubjectGroups = update(updatedSubjectGroups, {
      [index]: {
        subjects: { $set: sortedSubjects },
      },
    });
  });

  return updatedSubjectGroups;
};

export const isWithinAYTDurationDays = dateString => {
  // Convert the input string to a Date object
  const inputDate = new Date(dateString);
  // Get the current date
  const currentDate = new Date();
  // Calculate the number of milliseconds between the input date and the current date
  const millisecondsBetween = inputDate.getTime() - currentDate.getTime();
  // Calculate the number of days between the input date and the current date
  const daysBetween = millisecondsBetween / (1000 * 60 * 60 * 24);
  // Check if the number of days between the input date and the current date is less than or equal to 60

  const AYTDurationDays =
    getSettingValue({
      name: "AdminPortal:AYTDurationDays",
      readFromUserAndOrgLevel: true,
    }) || 60;

  return daysBetween <= parseInt(AYTDurationDays);
};

export const isPastGivenDate = dateString => {
  const inputDate = new Date(dateString);
  const currentDate = new Date();
  return inputDate < currentDate;
};

// This function will return the highest year group from a list of yeargroups
const calculateHighestYearGroupFromList = yearGroupsList => {
  let currentHighestYear = 0;
  let currentHighestYearGroupName = "";
  _.forEach(yearGroupsList, yearGroup => {
    const regex = /\b(19|20)\d{2}\b/g;
    const yearGroupName = _.get(yearGroup, "name", "");
    const yearMatchedFromYearGroupName = parseInt(
      yearGroupName.match(regex)?.[0]
    );
    if (yearMatchedFromYearGroupName > currentHighestYear) {
      currentHighestYear = yearMatchedFromYearGroupName;
      currentHighestYearGroupName = yearGroupName;
    }
  });
  return {
    currentHighestYearGroupName,
    currentHighestYear,
  };
};

// This function is expected to generate an intuitive name for the future year group.
export const generateFutureYearGroupName = (
  currentYearGroupList,
  futureAYEndYear
) => {
  const {
    currentHighestYearGroupName,
    currentHighestYear,
  } = calculateHighestYearGroupFromList(currentYearGroupList);
  if (currentHighestYear) {
    return currentHighestYearGroupName
      .replace(currentHighestYear, currentHighestYear + 1)
      .trim();
  } else {
    return (
      _.get(_.last(currentYearGroupList), "name", "") +
      ` (Batch of ${futureAYEndYear})`
    );
  }
};

export const getNextAcademicYearId = organizationId => {
  const academicYearsList = getAcademicYearsList(organizationId);
  const currentAcademicYear = getCurrentAcademicYear({
    organizationId: organizationId,
  });
  const currentAcademicYearEndDate = _.get(currentAcademicYear, "endDate");
  const allAcademicYearAfterCurrent = _.filter(
    academicYearsList,
    academicYear => {
      if (moment(academicYear.endDate).isAfter(currentAcademicYearEndDate))
        return academicYear;
    }
  );
  const AcademicYearInSortedOrder = _.orderBy(
    allAcademicYearAfterCurrent,
    o => {
      return moment(o.startDate).format("YYYYMMDD");
    },
    ["asc"]
  );
  const immediateNextAcademicYear = _.first(AcademicYearInSortedOrder);

  return { nextAcademicYear: immediateNextAcademicYear };
};

export const isAcademicYearTransitionAllowed = () => {
  return (
    ACLStore.can(ENABLE_AY_TRANSITION) &&
    canCarryOutAcademicYearTransitionForAccount()
  );
};

export const crossYearGroupStudentsForDPEnabled = () => {
  return ACLStore.can("FeatureFlag:DP1andDP2Students");
};

export const getAcademicSetupRoute = ({ curriculumProgramType }) => {
  switch (curriculumProgramType) {
    case "IB_MYP":
      return "mypAcademicSetup";
    case "IB_PYP":
      return "academicSetup";
    case "UBD":
      return "ubdAcademicSetup";
    case "IB_DP":
      return "dpAcademicSetup";
  }
};

const _getUserCourseMapFilters = ({
  archivalState = "ALL",
  academicYearIds = [],
}) => {
  return {
    archivalState,
    ...(academicYearIds ? { academicYearIds } : {}),
  };
};

export const getUserCourseMapFilters = _.memoize(
  _getUserCourseMapFilters,
  JSON.stringify
);

// Exporting the unmemoized versions for memory optimization
export { _getSelectedCurriculumObject as getSelectedCurriculumObjectV2 };
export { _getUserCourseMapFilters as getUserCourseMapFiltersV2 };

export const _getCourseCollaboratorMapFilters = ({
  archivalState = "ALL",
  excludedDesignationIds,
  academicYearId,
}) => {
  return {
    archivalState,
    ...(excludedDesignationIds ? { excludedDesignationIds } : {}),
    ...(academicYearId ? { academicYearIds: [academicYearId] } : {}),
  };
};

export const getCourseCollaboratorMapFilters = _.memoize(
  _getCourseCollaboratorMapFilters,
  JSON.stringify
);

export const getDuotoneToOutlinedMap = () => {
  const duotoneToOutlinedMap = {
    EnglishDuotone: "EnglishOutlined",
    HindiDuotone: "LanguageOutlined",
    FrenchDuotone: "LanguageOutlined",
    KoreanDuotone: "LanguageOutlined",
    SpanishDuotone: "LanguageOutlined",
    MandarinDuotone: "LanguageOutlined",
    LanguageAcquisitionDuotone: "GlobeOutlined",
    BiologyDuotone: "DnaOutlined",
    PhysicsDuotone: "PhysicsOutlined",
    ChemistryDuotone: "FunnelOutlined",
    SciencesDuotone: "ScienceOutlined",
    MathematicsDuotone: "MathematicsOutlined",
    MathsDuotone: "MathOutlined",
    GeographyDuotone: "GlobeOutlined",
    CivicsDuotone: "WeightOutlined",
    HistoryDuotone: "ScrollLetterOutlined",
    GlobalContextDuotone: "GlobeOutlined",
    BriefcaseDuotone: "PortfolioOutlined",
    ExtendedEssayDuotone: "EeOutlined",
    CasDuotone: "CasOutlined",
    TheoryofKnowledgeDuotone: "TheoryofKnowledgeOutlined",
    SportsDuotone: "BallOutlined",
    ArtDuotone: "PaintBrushOutlined",
    DanceDuotone: "DanceOutlined",
    MusicDuotone: "MusicOutlined",
    DesignDuotone: "TeacherResourceOutlined",
    ActionsDuotone: "LoudspeakerOutlined",
    PhysicalHealthEducationDuotone: "BallOutlined",
    LanguageLiteratureDuotone: "LanguageOutlined",
    OpenBookDuotone: "OpenBookTextOutlined",
    SubjectGenericDuotone: "PageBookmarkOutlined",
    FormsOfIntegrationDuotone: "PuzzlePieceOutlined",
  };

  return duotoneToOutlinedMap;
};

export const getIconComponent = ({
  icon,
  size = "small",
  hasBackground = false,
  containerStyle = {},
  imgAlt = "Entity icon",
}) => {
  const iconObject = getIconObject({
    size,
    hasBackground,
    containerStyle,
  });
  if (isURL(icon)) {
    const iconKey = _.findKey(iconObject, ({ iconName }) =>
      icon.includes(iconName)
    );
    if (iconKey) {
      return iconObject[iconKey].components;
    }
    return <img src={icon} style={containerStyle} alt={imgAlt} />;
  } else {
    if (_.has(iconObject, icon)) {
      return _.get(iconObject, `${icon}.components`, "");
    }
    return <img src={DEFAULT_ICON_URL} style={containerStyle} alt={imgAlt} />;
  }
};

export const getOutlinedIconComponent = ({
  icon,
  size = "small",
  hasBackground = false,
  containerStyle = {},
  className,
}) => {
  const duotoneToOutlinedMap = getDuotoneToOutlinedMap();

  const iconObject = getOutlinedIconObject({
    size,
    hasBackground,
    containerStyle,
    className,
  });

  if (isURL(icon)) {
    const duotoneIconKey = _.findKey(
      duotoneToOutlinedMap,
      (outlinedIcon, duotoneIconKey) => icon.includes(duotoneIconKey)
    );

    if (duotoneIconKey) {
      const outlinedIcon = duotoneToOutlinedMap[duotoneIconKey];
      return _.get(iconObject, `${outlinedIcon}.components`, "");
    }

    const iconKey = _.findKey(iconObject, ({ iconName }) =>
      icon.includes(iconName)
    );

    if (iconKey) return iconObject[iconKey].components;

    return <img src={icon} style={containerStyle} alt="" />;
  } else {
    if (_.has(duotoneToOutlinedMap, icon)) {
      const outlinedIcon = duotoneToOutlinedMap[icon];
      return _.get(iconObject, `${outlinedIcon}.components`, "");
    }

    if (_.has(iconObject, icon)) {
      return _.get(iconObject, `${icon}.components`, "");
    }
    return <img src={DEFAULT_ICON_URL} style={containerStyle} alt="" />;
  }
};

export const getDataGroupedByCurriculum = ({
  data,
  generateSortedData = true,
  fetchCurriculumProgramId = false,
}) => {
  const groupedByCurriculum = _.groupBy(data, item => {
    const {
      curriculumProgram: { id },
    } = item;
    return id;
  });

  if (_.size(groupedByCurriculum) <= 1 && !fetchCurriculumProgramId) {
    return data;
  }

  const formattedData = _.reduce(
    groupedByCurriculum,
    (result, groupedValues) => {
      const acronym = _.get(
        _.first(groupedValues),
        "curriculumProgram.acronym"
      );
      const curriculumProgramType = _.get(
        _.first(groupedValues),
        "curriculumProgram.type"
      );

      result.push({
        label: acronym,
        options: groupedValues,
        curriculumProgramType,
        ...(fetchCurriculumProgramId
          ? {
              curriculumProgramId: _.get(
                _.first(groupedValues),
                "curriculumProgram.id"
              ),
            }
          : {}),
      });

      return result;
    },
    []
  );

  if (!generateSortedData) {
    return formattedData;
  }

  const sortedData = _.orderBy(
    formattedData,
    [obj => CURRICULUM_TYPE_ORDER_MAPPING[obj.curriculumProgramType]],
    "asc"
  );
  return sortedData;
};

const getCourseGradeFilters = ({ academicYearId }) => {
  return {
    academicYearId,
  };
};

export const getCourseGradeFiltersMemoized = _.memoize(
  getCourseGradeFilters,
  JSON.stringify
);

export const getUserYearGroupMapFiltersMemoized = _.memoize(
  ({ academicYearId }) => {
    return {
      academicYearIds: [academicYearId],
    };
  },
  ({ academicYearId }) => academicYearId
);

export const getYearGroupGradeFiltersMemoized = _.memoize(
  ({ academicYearId }) => ({ academicYearId }),
  ({ academicYearId }) => academicYearId
);

/** Following set of utils are used for localisation banner */
export const getAreOperationsDisabledForLocalisation = ({
  isSwitcherLngInProgramLng,
}) => {
  if (
    ACLStore.can(ENABLE_PLANNER_ELEMENT_TRANSLATION_CONFIGURATION) &&
    !isSwitcherLngInProgramLng
  ) {
    return true;
  }
  return false;
};

export const getShouldShowLocalisationBanner = ({
  isSwitcherLngInProgramLng,
  programDataLanguages,
  isPreviousAcademicYearSelected,
}) => {
  if (
    !ACLStore.can(ENABLE_PLANNER_ELEMENT_TRANSLATION_CONFIGURATION) ||
    (_.size(programDataLanguages) === 1 && isSwitcherLngInProgramLng) ||
    isPreviousAcademicYearSelected
  ) {
    return false;
  }
  return true;
};

export const getLanguageLabel = ({ t, lng }) => {
  return t(
    _.get(_.find(LANGUAGE_OPTIONS, { value: lng }), "localisedLabel", "")
  );
};

export const getLocalisationBannerDetails = ({
  mode,
  t,
  datasetName,
  switcherLanguage,
  isSwitcherLngInProgramLng,
}) => {
  const switcherLanguageLabel = getLanguageLabel({ t, lng: switcherLanguage });

  if (isSwitcherLngInProgramLng) {
    switch (mode) {
      case "add": {
        return {
          message: t(
            "academicSetup:switcher_language_in_program_language_add_message",
            {
              datasetName,
              switcherLanguage: switcherLanguageLabel,
            }
          ),
          type: "info",
        };
      }
      case "edit": {
        return {
          message: t(
            "academicSetup:switcher_language_in_program_language_edit_message",
            {
              datasetName,
              switcherLanguage: switcherLanguageLabel,
            }
          ),
          type: "info",
        };
      }
    }
  } else {
    return {
      message: t(
        "academicSetup:switcher_language_not_in_program_language_message",
        { datasetName, switcherLanguage: switcherLanguageLabel }
      ),
      type: "warning",
    };
  }
};

export const convertStringToTestId = str => {
  return _.snakeCase(str);
};

export const convertStringToTestIdMemoized = _.memoize(
  params => convertStringToTestId(params),
  params => JSON.stringify(params)
);

const generateEventTestId = ({
  courseTitle,
  periodAbbreviation,
  rotationDay,
  startTime,
  endTime,
  date,
}) => {
  const eventTestId = _.compact([
    courseTitle && `courseTitle-${convertStringToTestIdMemoized(courseTitle)}`,
    periodAbbreviation &&
      `periodAbbr-${convertStringToTestIdMemoized(periodAbbreviation)}`,
    rotationDay && `rotationDay-${convertStringToTestIdMemoized(rotationDay)}`,
    date && `date-${convertStringToTestIdMemoized(date)}`,
    startTime &&
      `startTime-${convertStringToTestIdMemoized(
        moment(startTime, "HH:mm:ss").format("hh:mm")
      )}`,
    endTime &&
      `endTime-${convertStringToTestIdMemoized(
        moment(endTime, "HH:mm:ss").format("hh:mm")
      )}`,
  ]).join("-");

  return eventTestId;
};

export const generateEventTestIdMemoized = _.memoize(
  params => generateEventTestId(params),
  params => JSON.stringify(params)
);

export const handleKeyDown = ({
  e,
  callBack,
  functionParams = null,
  tabEscape = false,
  useEscape = false,
  tabFunction = callBack,
  tabFunctionParams = functionParams,
  customRef = null,
  escapeShiftTab = false,
  isLastPopoverElement = false,
  isPopover = false,
}) => {
  if (e?.key === "Enter") {
    e?.preventDefault();
    callBack(functionParams);
  }

  // closing the popover on escape key press
  if (useEscape && e?.key === "Escape") {
    e?.preventDefault();
    tabFunction(tabFunctionParams);
  }

  // prevent tabbing out of the popover
  if (tabEscape && e?.key === "Tab") {
    e?.preventDefault();
  }

  // closing the popover on shift + tab key press
  if (escapeShiftTab && e?.key === "Tab" && e?.shiftKey) {
    e?.preventDefault();
    callBack(functionParams);
  }

  // prevent focus from going out of the popover
  if (isLastPopoverElement && e?.key === "Tab") {
    e?.preventDefault();
    customRef.current?.querySelector("#close")?.focus();
  }

  if (isPopover) {
    const closeButton = customRef?.querySelector("#close");

    if (e?.key === "Tab") {
      if (e?.shiftKey) {
        if (document.activeElement === customRef) {
          e?.preventDefault();
          closeButton.focus();
        }
      } else {
        if (document.activeElement === closeButton) {
          e?.preventDefault();
          customRef?.focus();
        }
      }
    } else if (useEscape && e?.key === "Escape") {
      callBack(functionParams);
    }
  }
};

// Presence in both draft and published versions of the template will count as 1
export const getTemplateUsedInCount = ({ templates }) => {
  const templateIds = _.map(templates, "id");
  const draftTemplateIdsOfTemplates = _.filter(
    _.map(templates, template => _.get(template, "draftTemplate.id")),
    templateId => !_.isEmpty(templateId)
  );

  return _.size(_.difference(templateIds, draftTemplateIdsOfTemplates));
};

//To avoid cyclic dependency, utils is created here instead of creating it in RolesAndPermissionUtils.js
export const getRnPPermissionsForSidebarNodes = ({ item, nodes }) => {
  const permissions = [];

  const hasChildren = _.get(item, "children", []).length > 0;

  const hasSubTabs = _.get(item, "hasSubTabs", false);

  /**
   * In case of Sidebar, there are 2 types of nodes:
   * - Nodes having children(Ex: Template related nodes in Academic Setup)
   * - Nodes having children but shown via slider submenu(Ex: Grade Setup)(represented via hasSubTabs)
   *
   * - For the 1st case, to show node, permissions of all children should be enabled.
   * - For the 2nd case, we only consider permissions of the node itself.
   */
  if (hasChildren && !hasSubTabs) {
    const children = _.get(item, "children", []);

    _.forEach(children, childId => {
      const nodeItem = _.find(nodes, { uid: childId });

      if (nodeItem) {
        const nodePermissions = getRnPPermissionsForSidebarNodes({
          item: nodeItem,
          nodes,
        });

        permissions.push(...nodePermissions);
      }
    });
  }

  /**
   * If node has own permission then consider it as well.
   */
  const itemPermission = _.get(item, "permission");
  if (itemPermission) {
    permissions.push(itemPermission);
  }

  return permissions;
};

export const getAdminPortalFilteredRootNodesWithValidCurriculumPrograms = ({
  rootNodes,
  curriculumProgramIds,
  userCurriculumProgramIds,
}) => {
  if (!ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION)) {
    return {
      accessibleRootNodes: rootNodes,
      accessibleCurriculumProgramIds: curriculumProgramIds,
    };
  }

  const accessibleRootNodes = [];
  let accessibleCurriculumProgramIds = [];

  const hasAdminPortalAccess = ACLStorage.getModuleSettingsValueByContext(
    ADMIN_PORTAL_ACCESS_PERMISSION,
    []
  );

  accessibleCurriculumProgramIds = _.filter(
    userCurriculumProgramIds,
    curriculumProgramId => {
      return ACLStorage.getModuleSettingsValueByContext(
        PROGRAMME_WIDE_CONFIGURATIONS_ACCESS_PERMISSION,
        [
          {
            entityType: "CURRICULUM_PROGRAM",
            entityId: curriculumProgramId,
          },
        ]
      );
    }
  );

  const schoolConfigNode = _.find(rootNodes, { id: "SCHOOL_CONFIGURATIONS" });
  let curriculumConfigNode = _.find(rootNodes, {
    id: "CURRICULUM_CONFIGURATIONS",
  });

  if (hasAdminPortalAccess || !_.isEmpty(accessibleCurriculumProgramIds)) {
    accessibleRootNodes.push(schoolConfigNode);
  }

  if (!_.isEmpty(accessibleCurriculumProgramIds)) {
    curriculumConfigNode = update(curriculumConfigNode, {
      children: (children = []) =>
        _.filter(children, childId => {
          const { curriculumProgramId } = parseAdminMenuId(childId);
          return _.includes(
            accessibleCurriculumProgramIds,
            curriculumProgramId
          );
        }),
    });

    accessibleRootNodes.push(curriculumConfigNode);
  }

  return {
    accessibleRootNodes,
    accessibleCurriculumProgramIds,
  };
};

export const getFilteredMenuItemsWrtRnP = ({
  nodes,
  isCurrentAcademicYearSelected,
  isFutureAcademicYearSelected,
}) => {
  if (!ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION)) {
    return nodes;
  }
  const userInfo = getUserInfo();
  const curriculumProgramsObj = getOrganizationCurriculumProgramsFromCache(
    _.get(userInfo, "org_id")
  );
  const curriculumPrograms = _.get(
    curriculumProgramsObj,
    "curriculumPrograms",
    []
  );

  const curriculumProgramIds = _.map(curriculumPrograms, "id");
  const filteredNodes = [];

  _.forEach(nodes, node => {
    let newNode = { ...node };
    const { uid } = newNode;

    switch (uid) {
      case "SCHOOL_SETTINGS": {
        const isNodeVisible = getAdminPortalNodeVisibilityStatus({
          item: newNode,
          isCurrentAcademicYearSelected,
          isFutureAcademicYearSelected,
          curriculumProgramIds,
        });

        if (!isNodeVisible) {
          newNode = update(newNode, {
            children: { $set: ["SCHOOL_INFORMATION"] },
          });
        }

        break;
      }
      case "CLASS_ROSTER": {
        const isNodeVisible = getAdminPortalNodeVisibilityStatus({
          item: newNode,
          isCurrentAcademicYearSelected,
          isFutureAcademicYearSelected,
          curriculumProgramIds,
        });

        if (!isNodeVisible) {
          newNode = update(newNode, {
            children: { $set: [] },
          });
        }

        break;
      }

      case "LEARNING_COURSE_SETUP":
      case "COURSE_SETUP":
      case "TEACHER_SETUP":
      case "STUDENTS":
      case "FAMILY_MEMBERS": {
        const parentNode = _.find(nodes, { id: "CLASS_ROSTER" });
        const {
          accountLevelVisibility,
          programLevelVisibility,
          curriculumProgramIds: validCurriculumProgramIds,
        } = checkSchoolRosterIndividualLevelVisibilityWithCurriculumPrograms({
          item: parentNode,
          curriculumProgramIds,
        });

        if (accountLevelVisibility) break;

        if (programLevelVisibility) {
          newNode = update(newNode, {
            children: (children = []) =>
              _.filter(children, childId => {
                const { curriculumProgramId } = parseAdminMenuId(childId);

                let isVisible =
                  curriculumProgramId &&
                  _.includes(validCurriculumProgramIds, curriculumProgramId);

                if (uid === "LEARNING_COURSE_SETUP") {
                  isVisible = getIsLearningCoursesEnabled({
                    curriculumProgramId,
                  });
                }

                return isVisible;
              }),
          });

          break;
        }

        newNode = update(newNode, {
          children: { $set: [] },
        });
        break;
      }

      case "INTEGRATIONS": {
        const isNodeVisible = getAdminPortalNodeVisibilityStatus({
          item: newNode,
          isCurrentAcademicYearSelected,
          isFutureAcademicYearSelected,
          curriculumProgramIds,
        });

        if (!isNodeVisible) {
          newNode = update(newNode, {
            children: { $set: [] },
          });
          break;
        }

        if (
          ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION) &&
          ACLStore.can(ENABLE_PROGRAM_ROLES_FOR_INTEGRATIONS)
        ) {
          const {
            accountLevelVisibility,
            programLevelVisibility,
          } = checkIntegrationsIndividualLevelVisibilityWithCurriculumPrograms({
            item: node,
            curriculumProgramIds,
          });

          if (accountLevelVisibility) break;

          if (programLevelVisibility) {
            newNode = update(newNode, {
              children: {
                $set: INTEGRATION_NODES_ALLOWED_FOR_PROGRAM_LEVEL_ROLES,
              },
            });
          } else {
            newNode = update(newNode, {
              children: { $set: [] },
            });
          }
        }

        break;
      }
    }

    filteredNodes.push(newNode);
  });

  return filteredNodes;
};

export const getAdminPortalNodeVisibilityStatusByUID = ({
  uid,
  isCurrentAcademicYearSelected,
  isFutureAcademicYearSelected,
  curriculumPrograms,
}) => {
  const curriculumProgramIds = _.map(curriculumPrograms, "id");

  const { nodes } = getAdminMenuItemsMemoize();
  const node = _.find(nodes, { uid });

  if (!node) return false;

  return getAdminPortalNodeVisibilityStatus({
    item: node,
    nodes,
    isCurrentAcademicYearSelected,
    isFutureAcademicYearSelected,
    curriculumProgramIds,
  });
};

export const isRnPConsumptionEnabled = () => {
  return ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION);
};

export const isRnPConfigurationEnabled = () => {
  return ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONFIGURATION);
};

export const generateSubChildId = ({
  childId,
  curriculumProgramId,
  curriculumProgramType,
}) => {
  if (curriculumProgramId) {
    const parentIdWithCurriculum = `${removeIBPrefixFromCurriculumType(
      curriculumProgramType
    )}_${childId}`;
    return `${curriculumProgramId}:${parentIdWithCurriculum}`;
  }
  return `ALL_${childId}`;
};

/* Determines whether Toddle 2.0 UI should be rendered.
 *
 * IMPORTANT:
 * - This is for deciding between Toddle 1.0 UI and Toddle 2.0 UI.
 * - Currently, Toddle 2.0 UI is enabled whenever
 *   Account Configuration is enabled.
 *
 * Usage:
 * - Use this to decide which UI version to render
 * - Use this to decide whether to show "School" or "Programme" labels
 */

export const getIsToddle2UIEnabled = () => {
  return getIsAccountConfigurationEnabled();
};
